export default "__VITE_ASSET__ByEd$fc7__"